import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useDispatch } from 'react-redux';
// import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import i18next from 'i18next';
import PropTypes from 'prop-types';

// import loginImage from '../../assets/images/login/loginPage.jpg';
// import loginImage1 from '../../assets/images/login/loginPage1.png';
// import loginImage2 from '../../assets/images/login/loginPage2.png';
import loginImage from '../../assets/images/wejha_login_logo.png';
// import userIcon from '../../assets/icons/user1.png';
// import passwordIcon from '../../assets/icons/password1.png';

import { Input } from '../../shared/component/form/Input';
import Button from '../../shared/component/Button';

import auth from '../../utils/api/auth';
import feature from '../../utils/api/feature';
import {
  getLocalStorageItem,
  setLocalStorageItem,
  useRecaptcha,
  setCookieStorageItem,
  getCookieStorageItem,
  getI18Next,
} from '../../utils/helpers';
import { CloseIconLogin, WorldIcon } from '../../shared/component/svgIcon';
import DropDownMenu from '../../shared/component/DropDownMenu';
import { emailValidation } from '../../shared/component/form/Validation';
import { setErrorNotification } from '../../redux/slices/NotificationSlice';
import BackgroundLogin from './BackgroundLogin';

function Login(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { VerifyRecaptcha } = useRecaptcha();
  const currentLanguageCode = getI18Next();
  const data = getCookieStorageItem('secure-auth-access');
  const features = getLocalStorageItem('features');
  const role = getLocalStorageItem('role');

  const [loginButtonLoading, setLoginButtonLoading] = useState(false);
  const [loginButtonClicked, setLoginButtonClicked] = useState(false);
  const [logInButtonText, setLogInButtonText] = useState('login');
  const [logInCred, setLogInCred] = useState(null);
  const handleLanguage = (code) => {
    i18next.changeLanguage(code);
    window.location.reload();
  };
  const [currentIndex, setCurrentIndex] = useState(0);
  const videoRef = useRef(null);
  const menuList = [
    {
      code: 'en',
      name: 'English',
      function: handleLanguage,
      disabled: currentLanguageCode === 'en',
    },
    {
      code: 'ar',
      name: 'عربي (Arabic)',
      function: handleLanguage,
      disabled: currentLanguageCode === 'ar',
    },
  ];

  const videoData = [
    {
      src: 'https://signage-cms-dev.s3.ap-south-1.amazonaws.com/medias/weather.mp4',
      heading: t('wEATHER'),
      text: (
        t('weatherInfo')
      ),
    },
    {
      src: 'https://signage-cms-dev.s3.ap-south-1.amazonaws.com/medias/template.mp4',
      heading: t('tEMPLATES'),
      text: (
        t('templatesInfo')
      ),
    },
    {
      src: 'https://signage-cms-dev.s3.ap-south-1.amazonaws.com/medias/content.mp4',
      heading: t('cONTENTLAYOUT'),
      text: (
        t('contentLayoutInfo')
      ),
    },
  ];
  const handleVideoEnd = () => {
    setCurrentIndex((prev) => (prev + 1) % videoData.length);
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current.play();
    }
  }, [currentIndex]);

  //   const loginBanners = [
  //     {
  //       image: loginImage,
  //       objectFit: 'cover',
  //     },
  //     {
  //       image: loginImage1,
  //       objectFit: 'contain',
  //     },
  //     {
  //       image: loginImage2,
  //       objectFit: 'contain',
  //     },
  //   ];

  // const settings = {
  //   dots: false,
  //   lazyLoad: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   initialSlide: 0,
  //   cssEase: 'linear',
  //   prevArrow: null,
  //   nextArrow: null,
  //   autoplay: true,
  // };

  const [value, setValue] = useState({});
  const [disable, setDisable] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');
  // Function to handle email and password changes
  const changeHandle = (name, changeValue) => {
    setValue({ ...value, [name]: changeValue });
  };

  // Function to handle login request
  const submit = async () => {
    setErrorMsg('');
    setLoginButtonClicked(true);
    if (emailValidation(value?.email)) {
      setLoginButtonLoading(true);
      try {
        // Execute reCAPTCHA and get the token
        const recaptchaToken = await VerifyRecaptcha('login');
        const payload = { ...value, recaptchaToken };
        if (logInButtonText === 'sendOtp') {
          const sendOtpData = {
            email: value?.email,
            recaptchaToken,
          };
          const res = await auth.sendLogInOtp(sendOtpData);
          if (res) {
            setDisable(true);
            setLoginButtonLoading(false);
            setLogInButtonText('submit');
          }
        }
        if (logInButtonText === 'submit') {
          const otpData = {
            email: value?.email,
            logInOtp: value?.logInOtp,
            recaptchaToken,
          };
          await auth.verifyEmail(otpData)
            .then(async () => {
              setDisable(true);
              const token = logInCred?.tokens?.access?.token;
              const decoded = jwtDecode(token);
              const userData = { user: logInCred?.user };
              setCookieStorageItem('secure-auth-access', logInCred?.tokens?.access?.token);
              setCookieStorageItem('secure-auth-refresh', logInCred?.tokens?.refresh?.token);
              setLocalStorageItem('role', decoded?.role);
              setLocalStorageItem('data', userData);
              // If the user is within the register company,
              // then navigate to dashboard or navigate to company register form
              if (logInCred?.user?.company) {
                // If user is authenticated, fetch the features for that user
                const res = await feature.getFeatures();
                setLocalStorageItem('features', res?.data);
                navigate('/admin/templates');
                // Run a walkthrough based on new user login
                props?.setRunWalkthrough(!logInCred?.user?.walkthrough || false);
              } else {
                navigate('../register', { state: { formStage: 3, page: 'login' } });
              }
              setLoginButtonLoading(false);
            });
        }
        if (logInButtonText === 'login') {
          localStorage.removeItem('role');
          localStorage.removeItem('data');
          localStorage.removeItem('features');

          const response = await auth.login(payload);

          if (response) {
            const newLogInCred = response?.data;
            setLogInCred(newLogInCred);
            setLoginButtonLoading(false);
            if (newLogInCred?.user?.company?.two_factor) {
              setLogInButtonText('sendOtp');
            } else {
              setDisable(true);
              const token = newLogInCred?.tokens?.access?.token;
              const decoded = jwtDecode(token);
              const userData = { user: newLogInCred?.user };

              setCookieStorageItem('secure-auth-access', newLogInCred?.tokens?.access?.token);
              setCookieStorageItem('secure-auth-refresh', newLogInCred?.tokens?.refresh?.token);
              setLocalStorageItem('role', decoded?.role);
              setLocalStorageItem('data', userData);
              if (newLogInCred?.user?.company) {
                const res = await feature.getFeatures();
                setLocalStorageItem('features', res.data);
                navigate('/admin/templates');
                props?.setRunWalkthrough(!newLogInCred.user.walkthrough || false);
              } else {
                navigate('../register', { state: { formStage: 3, page: 'login' } });
              }
            }
          }
        }
      } catch (error) {
        setDisable(false);
        setLoginButtonLoading(false);
        if (error?.response?.data?.message) {
          setErrorMsg(error?.response?.data?.message);
        } else {
          dispatch(setErrorNotification(
            { message: 'Network error, Please check your network connection and try again' },
          ));
        }
      }
    }
  };
  const handleclose = () => {
    setErrorMsg(false);
  };

  // To enable and disable button state
  useEffect(() => {
    setErrorMsg('');
    if (logInButtonText === 'sendOtp' && value.email) {
      setDisable(false);
    } else if (logInButtonText === 'submit' && value.email && value.logInOtp && value.logInOtp.length === 6) {
      setDisable(false);
    } else if (logInButtonText === 'login' && value.email && value.password) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [value]);

  const handleResend = async () => {
    setLoginButtonClicked(true);
    setErrorMsg('');
    setLogInButtonText('sendOtp');
    if (emailValidation(value?.email)) {
      setLoginButtonLoading(true);
      try {
        // Execute reCAPTCHA and get the token
        const recaptchaToken = await VerifyRecaptcha('login');
        const payload = { email: value?.email, recaptchaToken };
        await auth.sendLogInOtp(payload);
        setDisable(true);
        setLoginButtonLoading(false);
        setLogInButtonText('submit');
      } catch (error) {
        setDisable(false);
        setLoginButtonLoading(false);
        if (error?.response?.data?.message) {
          setErrorMsg(error?.response?.data?.message);
        } else {
          setErrorMsg('An unexpected error occurred.');
        }
      }
    }
  };
  useEffect(() => {
    if (typeof token === 'string') {
      // Convert the access token expires date string to a Date object
      const decodeExpiryDate = jwtDecode(data);
      const expiryDate = new Date((decodeExpiryDate.exp) * (1000));

      // Get the current date and time
      const currentDate = new Date();

      // Check if the access token is expired
      if (expiryDate && expiryDate <= currentDate) {
        localStorage.removeItem('data');
        localStorage.removeItem('role');
        localStorage.removeItem('features');
        localStorage.removeItem('walkthroughCompleted');
      } else if ((expiryDate && expiryDate > currentDate)
        && features
        && role) {
        navigate('/admin/templates');
      }
    }
  }, []);
  return (
    <>
      <BackgroundLogin />

      <div className="login">
        <div className="page">
          <div className="banner-wrap">
            <div className="left-content">
              <img
                src={loginImage}
                alt="Logo"
                className="brand-logo"
              // style={{
              //   alignSelf: 'flex-start',
              //   display: 'block',
              //   margin: 0,
              //   padding: 0,
              // }}
              />
              <p className="caption-text">
                {t('effortlesslyCreate')}
                <span className="highlight-green"> {t('schedules')} </span>
                {t('andManage')}
                <span className="highlight-green"> {t('signage')}.</span>
              </p>
              <div className="tv-box">
                {/* You can place an image, animation, or SVG here */}
                <video
                  ref={videoRef}
                  src={videoData[currentIndex].src}
                  autoPlay
                  muted
                  playsInline
                  onEnded={handleVideoEnd}
                  className="video-box"
                />
              </div>
              <div className="sub-tv">
                {/* sub tv */}
              </div>
              <div className="sub-title">
                <div className="heading">{videoData[currentIndex].heading}</div>
                <div className="sub-text">
                  {videoData[currentIndex].text}
                </div>
              </div>
            </div>
          </div>
          <div className="form-session">
            {errorMsg && (
              <div className="error-wrapper">
                <p className="text-danger">{errorMsg}
                  <span
                    role="presentation"
                    onClick={handleclose}
                  >
                    <CloseIconLogin />
                  </span>
                </p>
              </div>
            )}
            <div className="form login-forms">
              <h1 className="loginTitle">{t('readyToEngageYourAudience')}</h1>
              {logInButtonText === 'sendOtp' && <h4 className="loginTitle1">{t('letsMakeItHappen')}</h4>}
              {logInButtonText === 'submit' && <h4 className="loginTitle1">{t('letsMakeItHappen')}</h4>}
              {logInButtonText === 'login' && <h4 className="loginTitle1">{t('letsMakeItHappen')}</h4>}
              <Input
                // icon={userIcon}
                label={t('username')}
                type="text"
                required={false}
                placeholder={t('enterUsername')}
                name="email"
                change={changeHandle}
                value={value?.email}
                error={!emailValidation(value?.email) && loginButtonClicked}
                errorMessage={t('invalidEmail')}
                readonly={logInButtonText === 'sendOtp'}
              />
              {logInButtonText === 'login'
                && (
                  <Input
                    // icon={passwordIcon}
                    label={t('password')}
                    type="password"
                    placeholder={t('enterPassword')}
                    required={false}
                    value={value?.password}
                    name="password"
                    change={changeHandle}
                    ar={currentLanguageCode}
                  />
                )}
              {logInButtonText === 'submit'
                && (
                  <Input
                    // icon={passwordIcon}
                    label={t('code')}
                    type="text"
                    required={false}
                    name="logInOtp"
                    change={changeHandle}
                    ar={currentLanguageCode}
                    value={value?.logInOtp}
                  />
                )}
              {logInButtonText === 'login'
                && <div className="forget"><Link to="/forgot-password">{t('forgotPassword?')}</Link></div>}
              <Button
                label={t(logInButtonText)}
                click={submit}
                classes={loginButtonLoading ? 'success-button loading-btn' : 'success-button'}
                loading={loginButtonLoading}
                disabled={disable}
              />
              {logInButtonText !== 'sendOtp'
                && (
                  <div className="have-an-account">
                    <p>{logInButtonText !== 'submit' ? t('dontHaveAnAccount?') : t('dontSeeACode?')}</p>
                    {logInButtonText !== 'submit'
                      ? (
                        <Link to="../register">
                          {t('register')}
                        </Link>
                      )
                      : (
                        <p
                          className={!loginButtonLoading ? 'resend-email' : 'resend-email-disabled'}
                          onClick={handleResend}
                          role="none"
                        >
                          {t('resendToEmail')}
                        </p>
                      )}
                  </div>
                )}
            </div>
          </div>
        </div>
        <div className={currentLanguageCode === 'ar'
          ? 'language-wrap-absolute-ar'
          : 'language-wrap-absolute'}
        >
          <p>{currentLanguageCode === 'en' ? 'English' : 'عربي '}</p>
          <DropDownMenu
            dropdown="dropdown"
            // icon={<span className="select-box-icon"><TopArrowIcon /></span>}
            icon={<WorldIcon />}
            action={menuList}
            tooltip="Language"
            editableName={false}
            from="language"
          />
        </div>
      </div>
    </>
  );
}

Login.propTypes = {
  setRunWalkthrough: PropTypes.node.isRequired,
};

export default Login;
